module.exports = __webpack_public_path__ + "img/care-offer-3.30d5d458.jpg";